<template>
  <template v-if="getShow">
    <Form class="p-4 enter-x" :model="formData" :rules="getFormRules" ref="formRef">
      <FormItem v-if="moreThanOneId" name="username" class="enter-x">
        <Select v-model:value="formData.username" :options="loginIds" />
      </FormItem>
      <FormItem name="password" class="enter-x">
        <StrengthMeter
          size="large"
          v-model:value="formData.password"
          :placeholder="t('sys.login.password')"
        >
          <template #prefix>
            <SvgIcon name="lock-on" size="18" />
          </template>
        </StrengthMeter>
      </FormItem>
      <FormItem name="confirmPassword" class="enter-x">
        <InputPassword
          size="large"
          visibilityToggle
          v-model:value="formData.confirmPassword"
          :placeholder="t('sys.login.confirmPassword')"
        >
          <template #prefix>
            <SvgIcon name="lock-on" size="18" />
          </template>
        </InputPassword>
      </FormItem>

      <FormItem class="enter-x">
        <Button type="primary" size="large" block @click="checkEmail" :loading="loading">
          {{ t('common.confirm') }}
        </Button>
        <section class="mt-6">
          <Alert v-show="sendSms" :message="t('sys.login.smsSended')" type="error" show-icon />
        </section>
      </FormItem>
    </Form>
  </template>
</template>
<script lang="ts" setup>
  import { reactive, ref, computed, unref, watch } from 'vue';
  import { Form, Input, Button, Alert, Select } from 'ant-design-vue';
  import { StrengthMeter } from '/@/components/StrengthMeter';
  import { SvgIcon } from '/@/components/Icon';
  import { useI18n } from '@mcex/locale';
  import {
    useFormRules,
    useFormValid,
    useForgetPassState,
    ForgetPassStateEnum,
    LoginStateEnum,
    useLoginState,
  } from './useLogin';
  import { ResetPassword, GetLoginIdList } from '/@/api/sys/user';

  import { createLocalStorage } from '/@/utils/cache';
  const ls = createLocalStorage();
  const FormItem = Form.Item;
  const InputPassword = Input.Password;
  const { t } = useI18n();

  const formRef = ref();
  const loading = ref(false);
  const sendSms = ref(false);
  // loginId列表
  const loginIds = ref([]);
  const formData = reactive({
    username: '',
    password: '',
    confirmPassword: '',
  });

  const { getFormRules } = useFormRules(formData);
  const { validForm } = useFormValid(formRef);

  const { getForgetPassState, setForgetPassState, forgetFormData } = useForgetPassState();
  const { getLoginState } = useLoginState();
  const getShow = computed(() => unref(getForgetPassState) === ForgetPassStateEnum.RESET_PASSWORD);
  // 是否强制重置密码
  const isFoceReset = computed(() => unref(getLoginState) === LoginStateEnum.FORCE_RESET_PASSWORD);

  const moreThanOneId = computed(() => unref(loginIds).length > 1);

  // 获取loginId列表
  async function GetLoginIds() {
    loginIds.value = [];
    const data = await GetLoginIdList({
      email: forgetFormData.email,
      otp: forgetFormData.otp,
    });

    data.length &&
      (loginIds.value = data.map((item) => ({ label: item.username, value: item.username })));
    // 默认选中第一个
    data.length && (formData.username = data[0].username);
  }
  async function checkEmail() {
    const data = await validForm();
    if (!data) return;
    try {
      loading.value = true;
      // TODO: 验证
      const queryParams = {
        email: forgetFormData.email,
        otp: forgetFormData.otp,
        password: formData.password,
        username: formData.username,
      };
      await ResetPassword(queryParams);
      setForgetPassState(ForgetPassStateEnum.SUCCESS);
    } catch (error) {
    } finally {
      loading.value = false;
    }
  }
  // 显示时获取loginId列表
  watch(
    () => getShow.value,
    (_bool) => {
      if (_bool) {
        // 强制重置密码时不获取loginId列表
        if (isFoceReset.value) {
          // 会员端重置密码跳转到此页时，从url中获取loginId
          const loginId = ls.get('loginId') as string;
          formData.username = loginId;
          return;
        }
        // 获取loginId列表
        GetLoginIds();
      }
    },
  );
</script>
<style lang="less" scoped>
  @link-cls: ~'@{namespace}-link';
  .@{link-cls} {
    color: @other-link-color;
  }
</style>
